/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Mahesh Vagicherla",
  logo_name: "mahesh vagicherla",
  nickname: "@b4s36t4",
  subTitle:
    "A passionate individual who always thrive to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1GWQlFVD3PPkZsJmRTLBlJCq0PCm93g9G/view?usp=sharing",
  portfolio_repository: "https://github.com/b4s36t4",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/b4s36t4",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mahesh-vagicherla-b81520159/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://www.youtube.com/channel/UC_amoXmmxSY9KusoDczDTXQ",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:maheshvagicherla99438@gmail.com",
    fontAwesomeIcon: "fas fa-envelope-open", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#000", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/b4s36t4",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/b4s36t4/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  // {
  //   name: "Freelancer",
  //   link: "https://www.freelancer.com/u/Maheshmahi19",
  //   fontAwesomeIcon: "simple-icons:freelancer", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
];

const skills = {
  data: [
    {
      title: "Python, Javascript & Bot development",
      fileName: "languagesIMG",
      skills: [
        "⚡ Used JS for backend purposes like building chatbots, API requests etc..",
        "⚡Starting at the Year of 2017 I've never stopped learning Python or using Python. And Python is my Favorite",
        "⚡ As companies and individual people thriving to automate their daily process or their bussieness, chatbots or automating scripts are become part and I've learned it well ;)",
      ],
      softwareSkills: [
        {
          skillName: "Javascript",
          fontAwesomeClassname: "ion-logo-javascript",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Chatbot Development",
          fontAwesomeClassname: "ion-chatbubble-ellipses",
          style: {
            backgroundColor: "transparent",
            color: "#000",
          },
        }
      ],
    },
    {
      title: "Frameworks & 3rd Party packages",
      fileName: "frameworkIMG",
      skills: [
        "⚡ Flask, Django and FastAPI for building backend services and API developments",
        "⚡ Discord.py, python-telegram-bot for building chatbot's for respective platform",
        "⚡ React-native, flutter for building apps for multiplatforms ;)",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Fast API",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "React Native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Selenium",
          fontAwesomeClassname: "logos:selenium",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Android Development",
          fontAwesomeClassname: "cib:android",
          style: {
            color: "green",
          },
        },
        {
          skillName: "PyQT5",
          fontAwesomeClassname: "logos:qt",
          style: {
            
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "logos:opencv",
          style: {
          },
        },
        {
          skillName: "Json",
          fontAwesomeClassname: "cib:json",
          style: {
            color: "#000",
          },
        },
        {
          skillName: "discord.py",
          fontAwesomeClassname: "la:discord",
          style: {
            color: "gray",
          },
        },
      ],
    },
    {
      title: "Cloud & Database",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Can use several Databases like MySql, MongoDB and PostgreSQL etc..",
      ],
      softwareSkills: [
        {
          skillName: "DigitalOcean",
          fontAwesomeClassname: "simple-icons:digitalocean",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "Mobile App Development",
      fileName: "DesignImg",
      skills: [
        "⚡ I did developed an App using Java by scraping my colleg's notification system, which will bring all notifcations/notices in hand",
        "⚡ I used react-native from scratch to build the same app which I developed using Java with JS ;)",
        "⚡ Learning flutter, it's bit hard for me :(",
      ],
      softwareSkills: [
        {
          skillName: "Android - Java",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "React-Native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    
  ],
};

const degrees = {
  degrees: [
    {
      title: "Rajiv Gandhi University of Knowledge Techonologies - NUZVID",
      subtitle: "B.Tech. in Computer Science & Engineering",
      logo_path: "rgukt.png",
      alt_name: "IIITDM Kurnool",
      duration: "2018 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Starting year 2019 I've started freelancing in fields on Bot Development, API development and Python Teaching!",
        // "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
      ],
      website_link: "https://rgutkn.ac.in",
    },
  ],
};

const certifications = {
  certifications: [
    
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship,Freelancing and Volunteership",
  description:
    "I've been working as a Freelancer from Year 2019 and I've done so many Projects as a Freelancer in freelancer.com.!",
    header_image_path: "experience.svg",
  sections: [
    {
      title:"Present",
      contentTitle:"As a Freelancer",
      contentText:"I've been working as a freelancer since a year.! I have done so many projects which includes Python,Bot development etc.."

    },
    {
      title:"Education",
      contentTitle:"10th Grade",
      contentText:"I've completed my 10th grade in Govt. High School, Y.Palem!"
    }
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My Projects are depended on vast types of third party packages like OpenCV, disord.py, python-telegram-bot etc.!",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_pic.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you withReact, Android, Cloud, React-Native, Javascript, Disocrd-bots and Opensource Development.",
  },
  // blogSection: {
  //   title: "Blogs",
  //   subtitle:
  //     "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
  //   link: "https://ashutoshhathidara.wordpress.com",
  //   avatar_image_path: "blogs_image.svg",
  // },
  addressSection: {
    title: "Address",
    subtitle:
      "Vinukonda Road, Yerragonda Palem, Prakasam ,Andhra Pradesh - 523327",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/2PxhB8WKCxh3yzQA8",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 6281083886",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
